'use client';

import { Box, Chip, Divider,Paper, Typography } from '@mui/material';

import MediaPlayer from './MediaPlayer';

export const MediaQuestion = ({questionData, hasOwnBold}) => {
  return (
    <Box maxWidth="md" mx="auto" p={4} display="flex" flexDirection="column" gap={4}>
      {/* Lista de medios */}
          <MediaPlayer
            type={questionData.multimedia?.type}
            src={questionData.multimedia?.urlMedia}
            title={questionData.questionName}
            description={questionData?.description}
            width="100%"
            height={'600px'}
            controls={true}
            autoplay={false}
            hasOwnBold={hasOwnBold}
          />
    </Box>
  );
};
